import React, { Component } from "react";
//import auth from "../services/authService";
//
import Table from "./common/table";
import Like from "./common/like";
import Lock from "./common/lock";
import Moment from "react-moment";
import TextArea from "./common/textArea";
 

//import { toast } from "react-toastify";
//import MessageCount from "./common/messageCount";

class DreamsTableForDoc extends Component {
  render() {
    let columns = [
    
      { path: "MO_Message", label: "MO_Message" },
      { path: "PersonStatus", label: "PersonStatus" },
     
    ];

    const { dreams, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={columns}
        data={dreams}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default DreamsTableForDoc;



// WEBPACK FOOTER //
// ./src/components/dreamTableForDoc.jsx